import { useState } from "react";
import { toast } from "sonner";
import { atajosHora, crearRecordatorio, mensajeRecordatorioError } from "../../lib/notas";

/** «Volver a llamar»: elegir hora (atajos o una propia) y se crea el recordatorio (/notes-v2/reminders). El aviso llega por la campanita interna. */
export default function VolverALlamar({ phone, noteId, onCreado }) {
  const [abierto, setAbierto] = useState(false);
  const [otra, setOtra] = useState("");
  const [enviando, setEnviando] = useState(false);

  const crear = async (iso) => {
    if (enviando) return;
    setEnviando(true);
    try {
      await crearRecordatorio({ phone, noteId, remindAt: iso });
      toast.success("Recordatorio creado. Avisaremos por la campanita.");
      setAbierto(false); setOtra("");
      onCreado?.(phone);
    } catch (e) { toast.error(mensajeRecordatorioError(e)); }
    finally { setEnviando(false); }
  };

  if (!phone) return null;
  return (
    <span className="nt-volver" data-testid="nt-volver-llamar" onClick={(e) => e.stopPropagation()}>
      <button type="button" className="nt-volver-b" title="Volver a llamar" aria-label="Volver a llamar" data-testid="nt-volver-abrir"
        onClick={() => setAbierto((v) => !v)}>⏰</button>
      {abierto && (
        <span className="nt-volver-menu" data-testid="nt-volver-menu">
          {atajosHora().map((a) => (
            <button type="button" key={a.key} className="nt-volver-op" data-testid={`nt-volver-${a.key}`} disabled={enviando} onClick={() => crear(a.iso)}>{a.label}</button>
          ))}
          <span className="nt-row">
            <input type="datetime-local" className="nt-in" aria-label="Otra hora" data-testid="nt-volver-otra" value={otra} onChange={(e) => setOtra(e.target.value)} />
            <button type="button" className="nt-btn sm" data-testid="nt-volver-otra-ok" disabled={enviando || !otra} onClick={() => crear(new Date(otra).toISOString())}>Listo</button>
          </span>
        </span>
      )}
    </span>
  );
}
